<div class="sidebar-wrapper">
  <div class="logo">
    <a href="https://www.hsbooster.eu" target="_blank" rel="noopener" class="simple-text">
      <div class="logo-img">
        <img src="/assets/img/logo.svg"/>
      </div>
    </a>
  </div>

  <ul class="nav">
    <li routerLinkActive="active" *ngFor="let menuItem of menuItems" class="{{ menuItem.class }}">
      <a *ngIf="auth.isAuthorized(menuItem.roles)" [routerLink]="[menuItem.path]">
        <i class="{{ menuItem.icon }}"></i>
        <p>{{ menuItem.title }}</p>
      </a>
    </li>
  </ul>
</div>
